import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { colors, fonts } from '../../theme';
export default {
  container: {
    position: 'sticky',
    top: '0',
    left: '0',
    right: '0',
    zIndex: '5',
    background: colors.pureWhite,
    '& > *': {
      borderBottom: "1px solid ".concat(colors.pureBlack),
      padding: '1.2rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  },
  title: _objectSpread(_objectSpread({
    justifyContent: 'flex-start',
    margin: '0'
  }, fonts.UniversBoldCondensed), {}, {
    textAlign: 'center',
    textTransform: 'uppercase',
    '& > *': {
      display: 'block'
    },
    '& > * + *': {
      marginTop: '0.2rem'
    },
    '& > i': {
      fontStyle: 'normal',
      fontSize: '1.4rem'
    }
  }),
  login: _objectSpread(_objectSpread({}, fonts.UniversRoman), {}, {
    fontSize: '1.2rem',
    textTransform: 'uppercase',
    '& a': {
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  }),
  '@media print': {
    login: {
      display: 'none'
    }
  }
};